import { render } from "./SlideHeroItem2.vue?vue&type=template&id=72173f3b&scoped=true"
import script from "./SlideHeroItem2.vue?vue&type=script&lang=js"
export * from "./SlideHeroItem2.vue?vue&type=script&lang=js"

import "./SlideHeroItem2.vue?vue&type=style&index=0&id=72173f3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72173f3b"]])

export default __exports__